import React from 'react'
import classNames from 'classnames'

import style from './TmoInput.module.css'

function TmoInput({
  value = '',
  onChange,
  type = 'text',
  size = 'md',
  className,
  tabIndex,
  inputType,
  testId,
  labelText,
  ...rest
}) {
  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <input
      className={classNames(
        inputType === 'primary' ? style.input_primary : style.input,
        inputType === 'primary' && value && style.input_outline_primary,
        style[size],
        className
      )}
      type={type}
      value={value}
      onChange={handleChange}
      tabIndex={tabIndex || '0'}
      data-testid={testId}
      aria-label={labelText}
      {...rest}
    />
  )
}

export default TmoInput
